export interface NavItemProps {
  id: string;
  messageId: string;
  title: string;
  icon?: string;
  exact?: boolean;
  url?: string;
  type?: string;
  count?: number;
  color?: string;
  auth?: string[];
  children?: NavItemProps[] | NavItemProps;
}

const routesConfig: NavItemProps[] = [
  {
    id: "patientdashboard",
    title: "Dashboards",
    messageId: "sidebar.patientdashboard",
    type: "item",
    icon: "/assets/images/patientIcons/dashboard.png",
    url: "/dashboard",
  },

  {
    id: "patientappointment",
    title: "Appointment",
    messageId: "sidebar.patientappointment",
    type: "item",
    icon: "/assets/images/patientIcons/appointments.png",
    url: "/appointment",
  },

  /* {
        id: 'communication',
        title: 'Communication',
        messageId: 'sidebar.patientcommunication',
        type: 'collapse',
        icon: '/assets/images/patientIcons/careoverview.png', 
        children: [
          {
            id: 'messages',
            title: 'Messages',
            messageId: 'sidebar.patientmessages',
            type: 'item',
            url: '/messages'
          },
          {
            id: 'tasks',
            title: 'Tasks',
            messageId: 'sidebar.patienttasks',
            type: 'item',
            url: '/tasks'
          },
          // {
          //   id: 'notifications',
          //   title: 'Notifications',
          //   messageId: 'sidebar.patientnotifications',
          //   type: 'item',
          //   url: '/notifications'
          // },
        ] 
      },*/

  // {
  //   id: 'patienttherapy',
  //   title: 'My Therpay Tasks',
  //   messageId: 'sidebar.patienttherapy',
  //   type: 'item',
  //   icon: '/assets/images/patientIcons/therapytasks.png',
  //   url: '/therapy-tasks',
  // },
  {
    id: "patienttherapy",
    title: "My Therpay Tasks",
    messageId: "sidebar.patienttherapy",
    type: "collapse",
    icon: "/assets/images/patientIcons/therapytasks.png",
    children: [
      {
        id: "patienttherapy",
        title: "Therpay Tasks",
        messageId: "sidebar.therapy",
        type: "item",
        url: "/therapy-tasks",
      },
      // {
      //   id: "othertasks",
      //   title: "Other Tasks",
      //   messageId: "sidebar.othertask",
      //   type: "item",
      //   url: "/other-tasks",
      // },
      {
        id: "messages",
        title: "Messages",
        messageId: "sidebar.patientmessages",
        type: "item",
        url: "/messages",
      },
    ],
  },

  // {
  //   id: 'patientselfhelp',
  //   title: 'Self-Help',
  //   messageId: 'sidebar.patientselfhelp',
  //   type: 'item',
  //   icon: '/assets/images/patientIcons/selfhelp.png',
  //   url: '/AppSelfHelf',
  // },

  // {
  //   id: 'patientselfhelp',
  //   title: 'Self-Help',
  //   messageId: 'sidebar.patientselfhelp',
  //   type: 'collapse',
  //   icon: '/assets/images/patientIcons/selfhelp.png',
  //   children: [
  //     {
  //       id: 'products',
  //       title: 'Products',
  //       messageId: 'sidebar.ecommerce.products',
  //       type: 'item',
  //       url: '/error-pages/coming-soon',
  //     },
  //   ],
  // },
  // {
  //   id: 'patientsignposting',
  //   title: 'Signposting',
  //   messageId: 'sidebar.patientsignposting',
  //   type: 'item',
  //   icon: '/assets/images/patientIcons/signposting.png',
  //   url:'/signposting',
  // },
  {
    id: "task",
    title: "Task",
    messageId: "sidebar.task",
    type: "collapse",
    icon: "/assets/images/settings/tasklist.png",
    children: [
      {
        id: "task-management",
        title: "Task List",
        messageId: "sidebar.taskList",
        type: "item",
        url: "/task-management",
      },
      {
        id: "task-create-patient",
        title: "Create Patient Task",
        messageId: "sidebar.createPatientTask",
        type: "item",
        url: "/task-create-patient",
      },
      // {
      //   id: "task-bin",
      //   title: "Task Bin",
      //   messageId: "sidebar.taskBin",
      //   type: "item",
      //   url: "/task-bin",
      // },
    ],
  },
  {
    id: "patientClinicalDocument",
    title: "Clinical Document",
    messageId: "sidebar.clinicalDocument",
    type: "item",
    icon: "/assets/images/patientRecords/upload-icon.png",
    url: "/clinical-document",
  },
  {
    id: "patientFAQ",
    title: "FAQ",
    messageId: "sidebar.patientFAQ",
    type: "item",
    icon: "/assets/images/patientIcons/help.png",
    url: "/faq",
  },

  // {
  //   id: 'patientmedical',
  //   title: 'Medical Records',
  //   messageId: 'sidebar.patientmedical',
  //   type: 'item',
  //   icon: '/assets/images/patientIcons/mediacalrecords.png',
  //   url: '/medical-records',
  // },
  // {
  //   id: 'patientpayments',
  //   title: 'Payments',
  //   messageId: 'sidebar.patientpayments',
  //   type: 'item',
  //   icon: '/assets/images/patientIcons/billing.png',
  //   url: '/payments',
  // },

  {
    id: "patientsettings",
    title: "Patient Settings",
    messageId: "sidebar.patientSettings",
    type: "item",
    icon: "/assets/images/patientIcons/settings.png",
    url: "/settings",
  },

  {
    id: "helpgroup",
    title: "Help",
    messageId: "sidebar.patientHelp",
    type: "group",
    children: [
      {
        id: "patientHelpSupport",
        title: "Help & Support",
        messageId: "sidebar.HelpSupport",
        type: "item",
        icon: "/assets/images/patientIcons/help.png",
        url: "/helpSupport",
      },
    ],
  },
];
export default routesConfig;
